<sc-master-detail [data]="data" [readOnly]="true" [saveAllMode]="true"
  (selectionChanged)="handleSelectionChange($event)" [newStyle]="true" [selection]="[current]">

  @if (this.optionsContext.dirty && !loading) {
  <ng-template masterDetailToolbar>
    <div class="actions">
      <sc-cancel-button fitWidth [disabled]="!this.optionsContext.dirty || loading"
        (click)="cancel()"></sc-cancel-button>
      <sc-content-spacer vertical></sc-content-spacer>
      <sc-save-button fitWidth primary
        [disabled]="!this.optionsContext.optionsValid || !this.optionsContext.constraintsValid || !this.optionsContext.dirty || loading"
        (click)="save()"></sc-save-button>
      <sc-content-spacer vertical double></sc-content-spacer>
    </div>
  </ng-template>
  }

  <sc-padding fitHeight>
    <sc-scroll-pane>

      @if (currentView === 'structure') {
      <div class="options-view-layout">
        <div class="dragable-elements">
          <div class="draggable-element" draggable="true" (dragstart)="onAddOptionStart($event)"
            (dragend)="onDragOptionEnd($event)">
            <sc-flex>
              <sc-icon iconClass="fa-plus"></sc-icon>
              <sc-content-spacer></sc-content-spacer>
              <sc-dictionary-label dictionaryKey="app-client.common.action.add"></sc-dictionary-label>
            </sc-flex>
          </div>
        </div>
        <app-transport-options-strcuture-editor [addOption]="draggedOption" [optionsContext]="optionsContext"
          class="editor-component">
        </app-transport-options-strcuture-editor>
      </div>
      }

      @if (currentView === 'constraints') {
      <app-transport-option-constraints-editor [optionsContext]="optionsContext" class="editor-component">
      </app-transport-option-constraints-editor>
      }

      @if (currentView === 'conditions') {
      <yard-conditions [optionsContext]="optionsContext">
      </yard-conditions>
      }

      @if (currentView === 'timeframepriority') {
      <app-time-priority-list [optionsContext]="optionsContext"></app-time-priority-list>
      }

      <app-service-response [responseMessages]="responseMessages"></app-service-response>

    </sc-scroll-pane>
  </sc-padding>

</sc-master-detail>
